import throttle from 'lodash/throttle'

const stickyElement = function(stickyElement, stickyClass, hideClass, stickyValue, animateClass) {
    let lastScrollTop = 0
    const top = window.pageYOffset || document.documentElement.scrollTop
    if(top > stickyValue) {
        stickyElement.classList.add(stickyClass)
        stickyElement.classList.add(hideClass)
    }
    window.addEventListener('scroll', throttle(function() {
        const top = window.pageYOffset || document.documentElement.scrollTop
        const topVal = stickyValue
        if(top < lastScrollTop) {
            stickyElement.classList.add(stickyClass)
            stickyElement.classList.remove(hideClass)
            stickyElement.classList.add(animateClass)
        }
        if(top <= topVal) {
            stickyElement.classList.remove(stickyClass)
            stickyElement.classList.remove(animateClass)
        }
        if(top > topVal && top > lastScrollTop) {
            stickyElement.classList.add(hideClass)
            stickyElement.classList.add(stickyClass)
        }
        lastScrollTop = top
    }, 250))
}

export default stickyElement